export const trialDateFormattingOptions = {
  weekday: 'short',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

export const getTrialEndDate = (trialLengthInDays = 15) => {
  const today = new Date();
  today.setDate(today.getDate() + trialLengthInDays);

  return today.toLocaleString('en-US', trialDateFormattingOptions);
};
